export const isItemDepartment = (dept = {}) => {
  return dept?.DepartmentLetter === "X";
};

export const validDept = (dept = {}) => {
  // Exclude if item list department is present.
  return !isItemDepartment(dept);
};
